// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BookOpen as RawBookOpen } from "lucide-react";
export const BookOpen = /* @__PURE__ */ createIcon(RawBookOpen, "BookOpen", 2);
